import React from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Phone, Users, Mail } from 'lucide-react';

const ParentGuardianFields = ({
    formData,
    setFormData,
    isUnder18,
    disabled = false
}) => {
    // Guardian fields only required for athletes UNDER 18
    if (!isUnder18) return null;

    return (
        <div className="border-t border-white/10 pt-6 mt-6">
            <div className="flex items-center gap-2 mb-4">
                <Users className="w-5 h-5 text-primary" />
                <h3 className="font-heading font-bold text-sm uppercase">Parent/Guardian Information</h3>
                <span className="text-xs text-orange-400 ml-2">(Required for athletes under 18)</span>
            </div>

            <div className="space-y-4">
                {/* Parent/Guardian Name */}
                <div className="space-y-2">
                    <Label className="text-xs tracking-widest uppercase text-muted-foreground">
                        Parent/Guardian Full Name *
                    </Label>
                    <Input
                        value={formData.parent_guardian_name || ''}
                        onChange={(e) => setFormData({ ...formData, parent_guardian_name: e.target.value })}
                        className="bg-[#0a1628] border-white/10 h-11"
                        placeholder="Enter parent/guardian full name"
                        disabled={disabled}
                        data-testid="parent-name-input"
                    />
                </div>

                {/* Parent/Guardian Mobile */}
                <div className="space-y-2">
                    <Label className="text-xs tracking-widest uppercase text-muted-foreground">
                        Parent/Guardian Contact Number *
                    </Label>
                    <div className="relative">
                        <Phone className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                        <Input
                            value={formData.parent_guardian_mobile || ''}
                            onChange={(e) => setFormData({ ...formData, parent_guardian_mobile: e.target.value })}
                            className="bg-[#0a1628] border-white/10 h-11 pl-10"
                            placeholder="+254 7XX XXX XXX"
                            disabled={disabled}
                            data-testid="parent-mobile-input"
                        />
                    </div>
                </div>

                {/* Parent/Guardian Email */}
                <div className="space-y-2">
                    <Label className="text-xs tracking-widest uppercase text-muted-foreground">
                        Parent/Guardian Email *
                    </Label>
                    <div className="relative">
                        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
                        <Input
                            type="email"
                            value={formData.parent_guardian_email || ''}
                            onChange={(e) => setFormData({ ...formData, parent_guardian_email: e.target.value })}
                            className="bg-[#0a1628] border-white/10 h-11 pl-10"
                            placeholder="parent@email.com"
                            disabled={disabled}
                            data-testid="parent-email-input"
                        />
                    </div>
                </div>

                {/* Parent Consent Checkbox */}
                <div className="flex items-start gap-3 p-4 bg-orange-500/10 border border-orange-500/30">
                    <input
                        type="checkbox"
                        id="parent_consent"
                        checked={formData.parent_consent || false}
                        onChange={(e) => setFormData({ ...formData, parent_consent: e.target.checked })}
                        className="mt-1 w-5 h-5 accent-primary cursor-pointer"
                        disabled={disabled}
                        data-testid="parent-consent-checkbox"
                    />
                    <label htmlFor="parent_consent" className="text-sm cursor-pointer">
                        <span className="font-semibold text-orange-400">Parental/Guardian Consent: * </span>
                        I confirm that I am the parent/guardian of this athlete and I give consent for their participation in sports activities and tournaments registered through this platform.
                    </label>
                </div>
            </div>
        </div>
    );
};

export default ParentGuardianFields;
